module.exports = {
  "country": "DK",
  "artist": "Olsen Brothers",
  "song": "Fly on the Wings of Love",
  "year": "2000",
  "place": "1",
  "spotify": "4v2RaPHSsTvNkggw3RqyeT"
};